import { AppLayout } from 'layouts';
import type { ProgramEventContentObjectDetail } from 'models';
import type { ReactNode } from 'react';
import { useProgramEventLayoutQuery } from '../queries';
import { ProgramEventLayoutSkeleton } from './program-event-layout-skeleton';
import { ProgramEventLayoutWrapper } from './program-event-layout-wrapper';

type P = {
  children: (event: ProgramEventContentObjectDetail) => ReactNode;
  eventId: string;
  header: (event: ProgramEventContentObjectDetail) => ReactNode;
  redirectToEventDetail: (id: string) => Promise<void>;
};

const ProgramEventLayout = ({ children, eventId, header, redirectToEventDetail }: P) => {
  const { data: event, error } = useProgramEventLayoutQuery({ eventId });

  return (
    <AppLayout error={error}>
      {event ? (
        <ProgramEventLayoutWrapper event={event} header={header} redirectToEventDetail={redirectToEventDetail}>
          {children}
        </ProgramEventLayoutWrapper>
      ) : (
        <ProgramEventLayoutSkeleton />
      )}
    </AppLayout>
  );
};
export default ProgramEventLayout;
